import AutoCompleteSelect from "component/Common/AutoCompleteSelect";
import useApiClient from "hooks/useApiClient";
import useAutoComplete from "hooks/useAutoComplete";
import useToggle from "hooks/useToggle";
import { useTranslation } from "react-i18next";
import { IoLocationSharp } from "react-icons/io5";
import Flatpickr from "react-flatpickr";
import { MdDeleteOutline } from "react-icons/md";
import SimpleSelect from "component/Common/simpleSelect";
import { useHotelContext } from "hooks/hotel/useHotelContext";
import useHotelSearchParams from "hooks/hotel/useHotelSearchParams";
import { dateFormater, dayFromDate } from "helpers/common";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import useGetHotelAvailability from "hooks/hotel/useGetHotelAvailability";
import MobileAutoComplete from "./MobileAutoComplete";
import { childrenAgesOptions } from "helpers/hotelHelper";
import MobileGuestsDropdown from "./MobileGuestsDropdown";
import { SlLocationPin } from "react-icons/sl";
import { useEffect, useState } from "react";

const mapHotelResponseToOptions = (data) => {
    return data.map((hotel) => ({
        id: hotel.id,
        description: hotel.description,
        descriptionEn: hotel.descriptionEn,
    }));
};

const HotelTab = () => {
    const { urls } = useApiClient();
    const { t } = useTranslation();
    const { isOpen: destIsOpen, toggle: desToggle } = useToggle();
    const { isOpen: guestsRoomsIsOpen, toggle: guestsRoomsToggle } =
        useToggle();
    const location = useLocation();
    const navigate = useNavigate();
    const { getHotelAvailability } = useGetHotelAvailability();
    const {
        term: destTerm,
        results: destResults,
        loading: destLoading,
        handleInputChange: handleDestInputChange,
    } = useAutoComplete({
        url: urls.hotel.cityAutocomplete,
        mapResponseToOptions: mapHotelResponseToOptions,
    });

    const { hotelSearchParams, availabilityLoading } = useHotelContext();
    const { updateHotelSearchParams, isReadyToSearch, updateGuests } =
        useHotelSearchParams();
    const [animate, setAnimate] = useState(false);

    useEffect(() => {
        setAnimate(true);
        return () => {
            setAnimate(false);
        };
    }, []);

    const search = (e) => {
        e.preventDefault();
        if (!location.pathname.includes("hotel-search")) {
            navigate("/hotel-search");
        }
        getHotelAvailability();
        localStorage.setItem("hotelState", JSON.stringify(hotelSearchParams));
    };

    const roomsInputValue = () => {
        let totalAdults = 0;
        let totalChildren = 0;
        let totalRooms = hotelSearchParams?.rooms.length;
        hotelSearchParams?.rooms.forEach((room) => {
            totalAdults += room.adults;
            totalChildren += room.children;
        });
        let displayedText = `${totalAdults} ${
            totalAdults > 1 ? t("adults") : t("adult")
        }, ${totalChildren} ${
            totalChildren > 1 ? t("children") : t("child")
        }, ${totalRooms} ${totalRooms > 1 ? t("rooms") : t("room")}`;
        return displayedText;
    };

    const getInputValue = (option) => {
        return option?.description.split("-")[0] || "";
    };

    return (
        <div className={` ${animate ? "fade-in-tab" : ""}`}>
            <div className="col-lg-12">
                <div className="tour_search_form">
                    <form>
                        <div className="row">
                            <div className="col-lg-5 col-md-12 col-sm-12 col-12">
                                <div className="flight_Search_boxed block md:hidden">
                                    <p>{t("destination")}</p>
                                    <input
                                        type="text"
                                        onClick={desToggle}
                                        value={getInputValue(
                                            hotelSearchParams?.destination
                                        )}
                                        placeholder="Where are you going?"
                                    />
                                    {hotelSearchParams?.destination ? (
                                        <span className="truncate text-ellipsis">
                                            {
                                                hotelSearchParams?.destination
                                                    ?.description
                                            }
                                        </span>
                                    ) : (
                                        <span className="text-transparent">
                                            .
                                        </span>
                                    )}
                                    <div className="plan_icon_posation">
                                        <SlLocationPin size={18} />
                                    </div>
                                </div>
                                <div className="flight_Search_boxed hidden md:block border-none ">
                                    <p>{t("destination")}</p>
                                    <AutoCompleteSelect
                                        name="hotel"
                                        options={destResults}
                                        value={destTerm}
                                        onInputChange={handleDestInputChange}
                                        isLoading={destLoading}
                                        selectedOption={
                                            hotelSearchParams?.destination ||
                                            null
                                        }
                                        onChange={(selectedOption) => {
                                            updateHotelSearchParams(
                                                "destination",
                                                selectedOption
                                            );
                                        }}
                                    />
                                    {hotelSearchParams?.destination ? (
                                        <span className="truncate text-ellipsis">
                                            {
                                                hotelSearchParams?.destination
                                                    ?.description
                                            }
                                        </span>
                                    ) : (
                                        <span className="text-transparent">
                                            .
                                        </span>
                                    )}
                                    <div className="absolute top-[15px] right-[15px] ">
                                        <IoLocationSharp
                                            size={25}
                                            className="text-paragraph-color"
                                        />
                                    </div>
                                </div>
                                <MobileAutoComplete
                                    type={"hotel"}
                                    paramName={"destination"}
                                    isOpen={destIsOpen}
                                    onHide={desToggle}
                                    placeholder={t("whereAreYouGoing")}
                                    id="destination"
                                />
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                                <div className="form_search_date h-full">
                                    <div className="flight_Search_boxed date_flex_area">
                                        <div className="Journey_date w-full">
                                            <p>{t("dates")}</p>
                                            <Flatpickr
                                                onChange={(dates) => {
                                                    updateHotelSearchParams(
                                                        "checkInDate",
                                                        dateFormater(dates[0])
                                                    );

                                                    dates.length > 1
                                                        ? updateHotelSearchParams(
                                                              "checkOutDate",
                                                              dateFormater(
                                                                  dates[1]
                                                              )
                                                          )
                                                        : updateHotelSearchParams(
                                                              "checkOutDate",
                                                              ""
                                                          );
                                                }}
                                                options={{
                                                    mode: "range",
                                                    altInput: true,
                                                    altFormat: "F j Y",
                                                    dateFormat: "Y-m-d",
                                                    minDate: "today",
                                                    showMonths: 2,
                                                    animate: true,
                                                    onOpen: function (
                                                        selectedDates,
                                                        dateStr,
                                                        instance
                                                    ) {
                                                        instance.nextMonthNav.addEventListener(
                                                            "click",
                                                            function (e) {
                                                                e.preventDefault();
                                                                instance.changeMonth(
                                                                    1
                                                                );
                                                            }
                                                        );
                                                        instance.prevMonthNav.addEventListener(
                                                            "click",
                                                            function (e) {
                                                                e.preventDefault();
                                                                instance.changeMonth(
                                                                    -1
                                                                );
                                                            }
                                                        );
                                                    },
                                                }}
                                                placeholder={t("selectDates")}
                                                className="w-full h-[36px]"
                                                value={[
                                                    hotelSearchParams?.checkInDate,
                                                    hotelSearchParams?.checkOutDate,
                                                ].filter(Boolean)}
                                            />
                                            {hotelSearchParams?.checkInDate ? (
                                                <span className="truncate text-ellipsis">
                                                    {hotelSearchParams?.checkOutDate
                                                        ? `${dayFromDate(
                                                              hotelSearchParams?.checkInDate
                                                          )}-${dayFromDate(
                                                              hotelSearchParams?.checkOutDate
                                                          )}`
                                                        : `${dayFromDate(
                                                              hotelSearchParams?.checkInDate
                                                          )}`}
                                                </span>
                                            ) : (
                                                <span className="text-transparent">
                                                    .
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3  col-md-6 col-sm-12 col-12">
                                <div className="flight_Search_boxed dropdown_passenger_area">
                                    <p>{t("guestsRooms")}</p>
                                    <div className="dropdown hidden md:block">
                                        <button
                                            className="dropdown-toggle final-count w-full text-start h-[36px] truncate"
                                            data-toggle="dropdown"
                                            type="button"
                                            id="dropdownMenuButton1"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            {roomsInputValue()}
                                        </button>
                                        <div
                                            onClick={(e) => {
                                                e.stopPropagation();
                                            }}
                                            className="dropdown-menu dropdown_passenger_info"
                                            aria-labelledby="dropdownMenuButton1"
                                        >
                                            <div className="flex flex-col">
                                                {hotelSearchParams?.rooms?.map(
                                                    (room, index) => {
                                                        return (
                                                            <div
                                                                className=""
                                                                key={index}
                                                            >
                                                                <div className="flex items-center justify-between">
                                                                    <div className="text-[14px]">
                                                                        {t(
                                                                            "room"
                                                                        )}{" "}
                                                                        {index +
                                                                            1}
                                                                    </div>
                                                                    <MdDeleteOutline
                                                                        size={
                                                                            20
                                                                        }
                                                                        color="red"
                                                                        cursor={
                                                                            "pointer"
                                                                        }
                                                                        onClick={() => {
                                                                            if (
                                                                                hotelSearchParams
                                                                                    .rooms
                                                                                    .length ===
                                                                                1
                                                                            ) {
                                                                                toast.error(
                                                                                    "You must have at least one room"
                                                                                );
                                                                                return;
                                                                            }
                                                                            updateHotelSearchParams(
                                                                                "rooms",
                                                                                hotelSearchParams.rooms.filter(
                                                                                    (
                                                                                        item,
                                                                                        i
                                                                                    ) =>
                                                                                        i !==
                                                                                        index
                                                                                )
                                                                            );
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div className="my-4 flex flex-col gap-2">
                                                                    <div className="flex items-center justify-between">
                                                                        <div className="text-[14px]">
                                                                            {t(
                                                                                "adults"
                                                                            )}
                                                                        </div>
                                                                        <div className="flex gap-2 items-center">
                                                                            <div
                                                                                onClick={() => {
                                                                                    updateGuests(
                                                                                        index,
                                                                                        "adults",
                                                                                        hotelSearchParams
                                                                                            .rooms[
                                                                                            index
                                                                                        ]
                                                                                            .adults -
                                                                                            1,
                                                                                        "sub"
                                                                                    );
                                                                                }}
                                                                                className="border-2 border-main-color size-6 text-lg font-semibold rounded-full flex items-center justify-center text-main-color cursor-pointer"
                                                                            >
                                                                                -
                                                                            </div>
                                                                            <div className="text-md  w-8 text-center ">
                                                                                {
                                                                                    hotelSearchParams
                                                                                        ?.rooms[
                                                                                        index
                                                                                    ]
                                                                                        .adults
                                                                                }
                                                                            </div>
                                                                            <div
                                                                                onClick={() => {
                                                                                    updateGuests(
                                                                                        index,
                                                                                        "adults",
                                                                                        hotelSearchParams
                                                                                            .rooms[
                                                                                            index
                                                                                        ]
                                                                                            .adults +
                                                                                            1,
                                                                                        "add"
                                                                                    );
                                                                                }}
                                                                                className="border-2 border-main-color size-6 text-lg font-semibold rounded-full flex items-center justify-center text-main-color cursor-pointer "
                                                                            >
                                                                                +
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="flex items-center justify-between">
                                                                        <div className="text-[14px]">
                                                                            {t(
                                                                                "children"
                                                                            )}
                                                                        </div>
                                                                        <div className="flex gap-2 items-center">
                                                                            <div
                                                                                onClick={() => {
                                                                                    updateGuests(
                                                                                        index,
                                                                                        "children",
                                                                                        hotelSearchParams
                                                                                            .rooms[
                                                                                            index
                                                                                        ]
                                                                                            .children -
                                                                                            1,
                                                                                        "sub"
                                                                                    );
                                                                                }}
                                                                                className="border-2 border-main-color size-6 text-lg font-semibold rounded-full flex items-center justify-center text-main-color cursor-pointer "
                                                                            >
                                                                                -
                                                                            </div>
                                                                            <div className="w-8 text-center ">
                                                                                {
                                                                                    hotelSearchParams
                                                                                        ?.rooms[
                                                                                        index
                                                                                    ]
                                                                                        .children
                                                                                }
                                                                            </div>
                                                                            <div
                                                                                onClick={() => {
                                                                                    updateGuests(
                                                                                        index,
                                                                                        "children",
                                                                                        hotelSearchParams
                                                                                            .rooms[
                                                                                            index
                                                                                        ]
                                                                                            .children +
                                                                                            1,
                                                                                        "add"
                                                                                    );
                                                                                }}
                                                                                className="border-2 border-main-color size-6 text-lg font-semibold rounded-full flex items-center justify-center text-main-color cursor-pointer "
                                                                            >
                                                                                +
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className=" flex flex-col gap-2 mt-2">
                                                                        {hotelSearchParams?.rooms[
                                                                            index
                                                                        ].childrenAges.map(
                                                                            (
                                                                                child,
                                                                                i
                                                                            ) => {
                                                                                return (
                                                                                    <div
                                                                                        key={
                                                                                            i
                                                                                        }
                                                                                        className="flex items-center gap-2 justify-between "
                                                                                    >
                                                                                        <div className="flex">
                                                                                            {t(
                                                                                                "child"
                                                                                            )}{" "}
                                                                                            {i +
                                                                                                1}
                                                                                        </div>
                                                                                        <div className="w-24">
                                                                                            <SimpleSelect
                                                                                                options={
                                                                                                    childrenAgesOptions
                                                                                                }
                                                                                                isClearable={
                                                                                                    false
                                                                                                }
                                                                                                searchable={
                                                                                                    false
                                                                                                }
                                                                                                placeholder="Age.."
                                                                                                value={childrenAgesOptions.find(
                                                                                                    (
                                                                                                        age
                                                                                                    ) =>
                                                                                                        age.value ===
                                                                                                        child
                                                                                                )}
                                                                                                onChange={(
                                                                                                    selectedOption
                                                                                                ) => {
                                                                                                    updateHotelSearchParams(
                                                                                                        "rooms",
                                                                                                        hotelSearchParams.rooms.map(
                                                                                                            (
                                                                                                                room,
                                                                                                                roomIdx
                                                                                                            ) => {
                                                                                                                if (
                                                                                                                    roomIdx ===
                                                                                                                    index
                                                                                                                ) {
                                                                                                                    return {
                                                                                                                        ...room,
                                                                                                                        childrenAges:
                                                                                                                            room.childrenAges.map(
                                                                                                                                (
                                                                                                                                    age,
                                                                                                                                    ageIdx
                                                                                                                                ) => {
                                                                                                                                    if (
                                                                                                                                        ageIdx ===
                                                                                                                                        i
                                                                                                                                    ) {
                                                                                                                                        return +selectedOption.value;
                                                                                                                                    }
                                                                                                                                    return age;
                                                                                                                                }
                                                                                                                            ),
                                                                                                                    };
                                                                                                                }
                                                                                                                return room;
                                                                                                            }
                                                                                                        )
                                                                                                    );
                                                                                                }}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            }
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                {index !==
                                                                    hotelSearchParams
                                                                        .rooms
                                                                        .length -
                                                                        1 && (
                                                                    <hr className="mx-10 mb-4" />
                                                                )}
                                                            </div>
                                                        );
                                                    }
                                                )}
                                                <div
                                                    onClick={() => {
                                                        if (
                                                            hotelSearchParams
                                                                .rooms
                                                                .length === 4
                                                        ) {
                                                            toast.error(
                                                                "You can add at most 4 rooms"
                                                            );
                                                            return;
                                                        }
                                                        updateHotelSearchParams(
                                                            "rooms",
                                                            [
                                                                ...hotelSearchParams.rooms,
                                                                {
                                                                    adults: 1,
                                                                    children: 0,
                                                                    childrenAges:
                                                                        [],
                                                                },
                                                            ]
                                                        );
                                                    }}
                                                    className="w-full rounded-sm bg-main-color py-2 font-semibold text-md cursor-pointer text-center text-white mt-4"
                                                >
                                                    {t("addRoom")}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="block md:hidden">
                                        <button
                                            className="dropdown-toggle final-count w-full text-start h-[36px]"
                                            onClick={guestsRoomsToggle}
                                            type="button"
                                        >
                                            {roomsInputValue()}
                                        </button>
                                        <MobileGuestsDropdown
                                            isOpen={guestsRoomsIsOpen}
                                            onHide={guestsRoomsToggle}
                                        />
                                    </div>
                                    <span className="invisible">.</span>
                                </div>
                            </div>
                            <div className="top_form_search_button">
                                <button
                                    onClick={search}
                                    className={`btn btn_theme btn_md ${
                                        (!isReadyToSearch() ||
                                            availabilityLoading) &&
                                        "cursor-not-allowed"
                                    }`}
                                    disabled={
                                        !isReadyToSearch() ||
                                        availabilityLoading
                                    }
                                >
                                    Search
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default HotelTab;
